<template>
  <Row :gutter="24">
    <Col
      class="showItem"
      :span="type == 'department' ? 8 : 6"
      v-for="(item, index) in list"
      :key="item.id + index"
    >
      <span v-if="type == 'department'">
        {{ item.topTitle ? `${item.title}-${item.topTitle}` : item.title }}
      </span>
      <span v-else>{{ item.title }}</span>
      <Icon v-if="!isDisable" type="md-close delItem" @click="delItem(item)" />
    </Col>
  </Row>
</template>
<script>
export default {
  name: 'selectShowList',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'normal'
    },
    isDisable: Boolean // 是否禁用
  },
  data() {
    return {};
  },
  methods: {
    delItem(deleteItem) {
      this.$emit('on-delete-item', deleteItem);
    }
  }
};
</script>
<style lang="less" scoped>
.showItem {
  margin-top: 10px;
}
.delItem {
  color: #ccc;
  margin-left: 10px;
  cursor: pointer;
}
</style>
